module.exports = __webpack_public_path__ + "static/media/logo_interattivo_negative.6be0e437.png";